import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";
import {Form, PayButton} from './styled'

export const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();

  const [clientSecret, setClientSecret] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [paymentIntent, setPaymentIntent] = useState(null);
  const [paymentIntentStatus, setPaymentIntentStatus] = useState(null);

  const [message, setMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    setClientSecret(new URLSearchParams(window.location.search).get(
      "payment_intent_secret"
    ));
  }, [stripe]);

  useEffect(() => {
    if (!stripe || !clientSecret) {
      return;
    }


    setIsLoading(true);
    stripe.retrievePaymentIntent(clientSecret).then((pi) => {
      setPaymentIntent(pi.paymentIntent);
      setIsLoading(false);
    });
  }, [clientSecret])

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const { paymentIntent, error } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required'
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setErrorMessage(error.message);
      } else {
        setErrorMessage("An unexpected error occurred");
      }

      setIsLoading(false);
      return;
    }

    switch (paymentIntent.status) {
      case "succeeded":
        setMessage("Payment succeeded!");
        break;
      case "processing":
        setMessage("Your payment is processing.");
        break;
      case "requires_payment_method":
        setMessage("Your payment was not successful, please try again.");
        break;
      default:
        setMessage("Something went wrong.");
        break;
    }

    setPaymentIntentStatus(paymentIntent.status)
    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs"
  }

  return (
    <Form>
      {!paymentIntentStatus && (
        <form id="payment-form" onSubmit={handleSubmit}>
          <PaymentElement id="payment-element" options={paymentElementOptions} />
            <PayButton disabled={isLoading || !stripe || !elements}  id="submit">
              <span id="button-text">
                {isLoading || !paymentIntent
                  ? <div className="spinner" id="spinner"></div>
                  : `Pay ${paymentIntent.amount/100} ${paymentIntent.currency.toUpperCase()}`
                }
              </span>
            </PayButton>
        </form>
      )}
      {message &&
        <div id="payment-message">{message}</div>
      }
    </Form>
  );
};